// ─────────────────────────────────────────────
//  Dashboard.js — StockIQ Home Dashboard
//  Phase 2: All 6 live widgets assembled
// ─────────────────────────────────────────────
import React from "react";
import { useAuth } from "../context/AuthContext";
import IndicesBar          from "../components/dashboard/IndicesBar";
import PortfolioSummaryCard from "../components/dashboard/PortfolioSummaryCard";
import GainersLosers       from "../components/dashboard/GainersLosers";
import WatchlistSnapshot   from "../components/dashboard/WatchlistSnapshot";
import PendingAlerts       from "../components/dashboard/PendingAlerts";
import SectorHeatmap       from "../components/dashboard/SectorHeatmap";
import "./Dashboard.css";

export default function Dashboard() {
  const { user } = useAuth();

  const hour = new Date().getHours();
  const greeting =
    hour >= 5 && hour < 12 ? "Good morning"   :
    hour >= 12 && hour < 17 ? "Good afternoon" :
    hour >= 17 && hour < 21 ? "Good evening"   : "Good night";

  const displayName = user?.email?.split("@")[0] || "Investor";

  return (
    <div className="dash-page">
      {/* Header */}
      <div className="dash-header">
        <div>
          <h1 className="dash-greeting">
            {greeting}, <span className="dash-name">{displayName}</span> 👋
          </h1>
          <p className="dash-subhead">
            {new Date().toLocaleDateString("en-IN", {
              weekday: "long", day: "numeric", month: "long", year: "numeric"
            })}
          </p>
        </div>
        <div className="dash-market-status">
          <MarketStatusBadge />
        </div>
      </div>

      {/* Row 1: Indices bar */}
      <IndicesBar />

      {/* Row 2: Portfolio | Watchlist | Alerts */}
      <div className="row g-3 mb-3">
        <div className="col-12 col-lg-5">
          <PortfolioSummaryCard />
        </div>
        <div className="col-12 col-lg-4">
          <WatchlistSnapshot />
        </div>
        <div className="col-12 col-lg-3">
          <PendingAlerts />
        </div>
      </div>

      {/* Row 3: Gainers/Losers | Sector Heatmap */}
      <div className="row g-3">
        <div className="col-12 col-xl-6">
          <GainersLosers />
        </div>
        <div className="col-12 col-xl-6">
          <SectorHeatmap />
        </div>
      </div>
    </div>
  );
}

function MarketStatusBadge() {
  const now     = new Date();
  const day     = now.getDay();
  const hour    = now.getHours();
  const minutes = now.getMinutes();
  const timeVal = hour * 60 + minutes;

  const isWeekday   = day >= 1 && day <= 5;
  const preOpen     = 9 * 60;
  const marketOpen  = 9 * 60 + 15;
  const marketClose = 15 * 60 + 30;

  let status = "closed";
  let label  = "Market Closed";
  let dot    = "dot-red";

  if (isWeekday) {
    if (timeVal >= preOpen && timeVal < marketOpen) {
      status = "preopen"; label = "Pre-Open"; dot = "dot-yellow";
    } else if (timeVal >= marketOpen && timeVal < marketClose) {
      status = "open"; label = "Market Open"; dot = "dot-green";
    }
  }

  return (
    <div className={`ms-badge ${status}`}>
      <span className={`ms-dot ${dot}`} />
      {label}
    </div>
  );
}